<template>
  <div class="passPhoto" v-if="visaPageImage">
    <p>签证图例</p>
    <div class="example">
      <img :src="visaPageImage" alt="visa" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'visaPage',
  props: ['visaPageImage'],
};
</script>
<style scoped>
.passPhoto {
  padding: 0.2rem;
  font-size: 0.14rem;
  color: #6f6f6f;
  text-align: center;
  background-color: #fff;
  margin-top: 0.15rem;
}
.passPhoto .example {
  width: 3.2rem;
  /* height: 2.14rem; */
  margin: 0 auto;
  padding: 0.03rem;
  border-top: 0.15rem solid #f3f4f6;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.passPhoto .example img {
  width: 100%;
  /* height: 100% */
}
</style>
